"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var useStyles = (0, _reactJss.createUseStyles)({
  primaryFieldContainer: {
    position: 'absolute',
    top: function top(_ref) {
      var theme = _ref.theme;
      return theme.scale * 60;
    },
    maxWidth: function maxWidth(_ref2) {
      var theme = _ref2.theme;
      return theme.scale * 320;
    }
  }
});
exports.useStyles = useStyles;
//# sourceMappingURL=styles.js.map